import { Box } from '@mui/material';
import { Button } from '@portals/core/src/components/Button/Button';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import { theme } from '@portals/core/src/themes/immobilien/main';
import { getFixedT } from 'i18next';
import React from 'react';

import { getStyles } from '../../EstateContact.styles';
import { LegalCheckbox } from '../LegalCheckbox/LegalCheckbox';

interface FormFooterSectionProps {
  isUserEstate: boolean;
  showPrivacyPolicy: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  showConsumerInformation: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  consumerInformation?: string;
  isSubmitting: boolean;
  isValid: boolean;
}

const t = getFixedT(null, 'core-immobilien');

export const FormFooterSection = ({
  isUserEstate,
  showPrivacyPolicy,
  showConsumerInformation,
  consumerInformation,
  isSubmitting,
  isValid,
}: FormFooterSectionProps): React.ReactElement => {
  const styles = getStyles(theme);

  return (
    <Box sx={styles.footerContainer}>
      <Typography variant="button">{t('contactForm.required')}</Typography>
      <Box sx={styles.sendContainer}>
        {!isUserEstate && (
          <LegalCheckbox
            showPrivacyPolicy={showPrivacyPolicy}
            showConsumerInformation={showConsumerInformation}
            consumerInformation={consumerInformation}
          />
        )}

        <Button
          variant="standard"
          color="primary"
          disabled={!isValid || isSubmitting}
          type="submit"
          sx={styles.sendButton}
        >
          {t('contactForm.sendMessage')}
        </Button>
      </Box>
    </Box>
  );
};

FormFooterSection.displayName = 'FormFooterSection';
